<breadcrumb endText="Subject List" [navigations]="breadcrumbNavs" />
<div class="m-5">
  <div class="flex justify-between">
    <div class="font-medium text-xl">
      Subject List
    </div>
    <clear-button (click)="subjectConfig()" [faIcon]="faPlus" text="Create new Subject" />
  </div>
  <hr />
  @for (item of items; track item; let i = $index) {
    <div [ngClass]="i % 2 === 0? 'flex justify-between mt-2 p-2 rounded-[8px]': 'flex justify-between mt-2 p-2 rounded-[8px] bg-gray-100'">
      {{item.name}}
      <div class="mr-3">
        <dropdown-menu [menuItems]="item.items" aria-label="Subject Menu"/>
      </div>
    </div>
  }
  <per-page-pagination
    [(currentPagination)]="currentPagination"
    perPageText="Submissions"
    (perPageFunction)="handleServiceCall()"
    (decrementPageFunction)="handleServiceCall()"
    (incrementPageFunction)="handleServiceCall()"
    />
  </div>
